//
// ProjectModulesInspector
//
// Project Module inspector; show name and version

import { observer } from 'mobx-react-lite'
import { useStore } from '../../stores'

import { VView } from '../../appview'
import { Header, Property, Text } from '../../components'
import { useMousePopover } from '../../hooks/useMousePopover'
import { ModuleUnregisterMenu } from '../../menus'

export const ProjectModulesInspector = observer(function ProjectModulesInspector({
    project,
    moduleName,
}) {
    const { app, data } = useStore()

    // ContextMenus
    const UnregisterContextMenu = useMousePopover(ModuleUnregisterMenu)

    const module = data.modules.get(moduleName)
    if (!module) return null

    const onUnregisterModuleAction = () => {
        module.unregisterModule()
    }

    const onCancel = () => {}

    const onAction = action => {
        const actions = {
            unregister_module: onUnregisterModuleAction,
            cancel: onCancel,
        }
        if (!(action in actions)) {
            console.log(`onAction: unhandled action '${action}'`)
            return
        }
        UnregisterContextMenu.hide()
        actions[action]()
    }

    return (
        <VView grow className="panel">
            <UnregisterContextMenu.Panel onAction={onAction} />
            <Header>{app.text('Module info')}</Header>
            <Property className="cc-packed" label={app.text('name')}>
                <Text
                    onContextMenu={e => {
                        UnregisterContextMenu.onShow(e)
                    }}
                >
                    {module.name}
                </Text>
            </Property>
            <Property className="cc-packed" label={app.text('version')}>
                <Text>{module.version}</Text>
            </Property>
        </VView>
    )
})
